// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"ExternalLink_wrapper__kDnpq","externalLink":"ExternalLink_externalLink__A75RN"};